import React from 'react'
import { Sparkles } from 'lucide-react'

export default function TypingIndicator() {
  return (
    <div style={{
      display: 'flex',
      gap: '14px',
      padding: '20px 0',
      alignItems: 'flex-start',
      animation: 'fadeInUp 0.2s ease',
    }}>
      {/* Avatar */}
      <div style={{
        width: 34,
        height: 34,
        borderRadius: '10px',
        background: 'var(--accent)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        marginTop: 2,
      }}>
          <img src='/images/fmt_logo.png' width={32} />
      </div>

      {/* Dots */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        paddingTop: '10px',
      }}>
        {[0, 1, 2].map(i => (
          <div
            key={i}
            style={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              background: 'var(--text-muted)',
              animation: 'pulse 1.2s ease-in-out infinite',
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </div>
    </div>
  )
}
